


































































































































































































































































































































































































































































































































































































































































































import {Component, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitRoundRewardCollection} from '@/model/collection/OrbitRoundRewardCollection'
import {OrbitRoundReward} from '@/model/resource/OrbitRoundReward'
import {DateHelper} from '@/helpers/DateHelper'
import {$} from '@/facade'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import OrbitApproveRewardModal from '@/components/orbit/OrbitApproveRewardModal.vue'
import OrbitDistributeRewardModal from '@/components/orbit/OrbitDistributeRewardModal.vue'
import {InputCheckbox, InputSelect} from '@simpli/vue-input'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {
  OrbitNetworkHelper,
  OrbitNetworkOption,
} from '@/helpers/OrbitNetworkHelper'
import {NeoHelper} from '@/helpers/NeoHelper'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import {OrbitRoundCollection} from '@/model/collection/OrbitRoundCollection'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'

type RoundOption = {$id: number; $tag: string}
type StatusFilterOption = {$id: string; $tag: string}

@Component({
  components: {
    ConnectWalletModal,
    OrbitApproveRewardModal,
    OrbitDistributeRewardModal,
    InputCheckbox,
    InputSelect,
  },
  computed: {
    DateHelper() {
      return DateHelper
    },
  },
})
export default class ListOrbitRewardsView extends MixinScreenSize {
  collection = new OrbitRoundRewardCollection()
  isUpdating = false
  showApproveModal = false
  showDistributeModal = false
  selectedReward: OrbitRoundReward | null = null
  selectedRewards: OrbitRoundReward[] = []
  filterAddress = ''
  filterTimeout: ReturnType<typeof setTimeout> | null = null
  isOwnerWallet = false
  isSyncing = false
  rewardStatusFilter: string | null = null
  networkFilter: string | null = null
  roundOptions: RoundOption[] = []
  selectedRoundToDistribute: RoundOption | null = null
  roundByNumber: Record<number, any> = {}
  /** Per-token transaction count (all projects using that token). Key = `${address}|${round}|${idTokenPricedFk}` */
  transactionCountMap: Record<string, number> = {}
  isLoadingTransactionCounts = false
  claimEndByRound: Record<number, number> = {}

  get approvableRewards(): OrbitRoundReward[] {
    return (this.collection.items || []).filter(
      (item: OrbitRoundReward) =>
        item.status === 'pending' &&
        !(item.orbitRound && item.orbitRound.isRunning)
    )
  }

  get statusFilterOptions(): StatusFilterOption[] {
    const t = (key: string) => this.$translate(key)
    return [
      {$id: '', $tag: t('view.ListOrbitRewardsView.filterStatusAll')},
      {
        $id: 'pending',
        $tag: t('view.ListOrbitRewardsView.filterStatusPending'),
      },
      {
        $id: 'approved',
        $tag: t('view.ListOrbitRewardsView.filterStatusApproved'),
      },
      {
        $id: 'rejected',
        $tag: t('view.ListOrbitRewardsView.filterStatusRejected'),
      },
      {
        $id: 'claimed',
        $tag: t('view.ListOrbitRewardsView.filterStatusClaimed'),
      },
      {
        $id: 'distributed_to_others',
        $tag: t('view.ListOrbitRewardsView.filterStatusDistributedToOthers'),
      },
      {
        $id: 'expired',
        $tag: t('view.ListOrbitRewardsView.filterStatusExpired'),
      },
    ]
  }

  get networkFilterOptions(): OrbitNetworkOption[] {
    return OrbitNetworkHelper.options(this.$translate('view.orbitNetwork.all'))
  }

  get networkFilterSelectValue(): OrbitNetworkOption | null {
    return OrbitNetworkHelper.optionOf(
      this.networkFilterOptions,
      this.networkFilter
    )
  }

  set networkFilterSelectValue(option: OrbitNetworkOption | null) {
    const next = !option || option.$id === '' ? null : option.$id
    if (next === this.networkFilter) return

    this.networkFilter = next
    this.clearSelection()
    this.populateResources()
  }

  networkLabel(item: OrbitRoundReward): string {
    return OrbitNetworkHelper.label(item.blockchainVersion?.networkIdentifier)
  }

  networkBadgeClass(item: OrbitRoundReward): string {
    return OrbitNetworkHelper.badgeClass(
      item.blockchainVersion?.networkIdentifier
    )
  }

  get statusFilterSelectValue(): StatusFilterOption | null {
    const opts = this.statusFilterOptions
    if (opts.length === 0) return null
    const key = this.rewardStatusFilter === null ? '' : this.rewardStatusFilter
    return opts.find(o => o.$id === key) ?? opts[0]
  }

  set statusFilterSelectValue(option: StatusFilterOption | null) {
    if (!option) {
      if (this.rewardStatusFilter !== null) {
        this.rewardStatusFilter = null
        this.populateResources()
      }
      return
    }
    const next = option.$id === '' ? null : option.$id
    if (next === this.rewardStatusFilter) return
    this.rewardStatusFilter = next
    this.populateResources()
  }

  mounted() {
    this.populateResources()
    this.checkOwnerWallet()
    this.populateRoundOptions()
  }

  private toMs(d: any): number | null {
    if (!d) return null
    const t = new Date(d as any).getTime()
    return Number.isNaN(t) ? null : t
  }

  get selectedRoundEntity() {
    if (!this.selectedRoundToDistribute) return null
    return this.roundByNumber[this.selectedRoundToDistribute.$id] || null
  }

  get distributeDisabledReason(): string | null {
    if (!this.$walletAdapter.n3Address) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonNoWallet'
      )
    }
    if (!this.isOwnerWallet) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonNotOwner'
      )
    }
    if (!this.selectedRoundToDistribute) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonSelectRound'
      )
    }
    const r = this.selectedRoundEntity
    if (!r) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonNoRound'
      )
    }

    const claimEndMs = this.toMs(r.claimEndsAt)
    const distEndMs = this.toMs(r.distributionEndsAt)
    const finishedMs = this.toMs(r.finishedAt)
    if (claimEndMs == null || distEndMs == null) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonMissingPhaseDates'
      )
    }

    const now = Date.now()

    if (now > distEndMs) {
      if (finishedMs != null) {
        if (now >= finishedMs) {
          return this.$translate(
            'view.ListOrbitRewardsView.distributeReasonFinalized'
          )
        }
        return this.$translate(
          'view.ListOrbitRewardsView.distributeReasonCannotDistributeAnymore'
        )
      }
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonCannotDistributeAnymore'
      )
    }

    if (now < claimEndMs) {
      return this.$translate(
        'view.ListOrbitRewardsView.distributeReasonClaimNotEnded'
      )
    }

    return null
  }

  async populateRoundOptions() {
    try {
      const col = new OrbitRoundCollection()
      col.orderBy = 'round'
      col.asc = false
      // Distribution signs on the bar's network, so only its rounds may be picked.
      col.networkIdentifier = currentN3Network()
      col.limit = 999
      col.perPage = 999
      await col.queryAsPage()

      const items = col.items || []

      this.roundByNumber = items.reduce((acc: Record<number, any>, r: any) => {
        const rn = Number(r?.round)
        if (Number.isNaN(rn) || rn <= 0) return acc

        const current = acc[rn]
        if (!current || this.isPreferredRoundRow(r, current)) acc[rn] = r

        return acc
      }, {})

      this.roundOptions = Object.keys(this.roundByNumber)
        .map(Number)
        .sort((a, b) => b - a)
        .map(rn => ({$id: rn, $tag: `Round #${rn}`}))

      if (!this.selectedRoundToDistribute && this.roundOptions.length > 0) {
        this.selectedRoundToDistribute = this.roundOptions[0]
      }
    } catch (e) {
      console.error('Failed to load orbit rounds for distribution:', e)
      this.roundOptions = []
      this.selectedRoundToDistribute = null
    }
  }

  private isPreferredRoundRow(candidate: any, current: any): boolean {
    const candidateIsRunning = !!candidate?.isRunning
    const currentIsRunning = !!current?.isRunning
    if (candidateIsRunning !== currentIsRunning) return candidateIsRunning

    return (
      Number(candidate?.idOrbitRoundPk ?? 0) >
      Number(current?.idOrbitRoundPk ?? 0)
    )
  }

  openDistributeRewardsModal() {
    if (this.distributeDisabledReason) return
    this.showDistributeModal = true
  }

  async closeDistributeRewardsModal() {
    this.showDistributeModal = false
    await this.populateRoundOptions()
    await this.populateResources()
  }

  applyCollection() {
    this.collection.orderBy = 'round'
    this.collection.asc = false
    this.collection.limit = 10
    this.collection.perPage = 10
    this.collection.statusFilter = this.rewardStatusFilter
    this.collection.networkIdentifier = this.networkFilter
  }

  async populateResources() {
    this.applyCollection()
    await $.await.run('softQuery', async () => {
      await this.collection.queryAsPage()
      await this.populatePageDetails()
    })
  }

  onBeforePaginationChange() {
    this.isLoadingTransactionCounts = true
  }

  async onPaginationChange() {
    await this.populatePageDetails()
  }

  onPaginationError() {
    this.isLoadingTransactionCounts = false
  }

  async populatePageDetails() {
    this.claimEndByRound = await OrbitHelper.buildClaimEndByRoundMap(
      this.collection.items || []
    )
    await this.fetchTransactionCounts()
  }

  async fetchTransactionCounts() {
    const items = this.collection.items || []
    if (items.length === 0) {
      this.transactionCountMap = {}
      return
    }

    this.isLoadingTransactionCounts = true
    this.transactionCountMap = {}

    const orbitTransactionCollection = new OrbitTransactionCollection()

    const seenKey = new Set<string>()
    await Promise.allSettled(
      items.map(async (reward: OrbitRoundReward) => {
        const address = reward.address
        const round = reward.orbitRound?.round
        const idTokenPricedFk = reward.tokenPriced?.idTokenPricedPk

        if (!address || round == null || idTokenPricedFk == null) return

        const key = `${address}|${round}|${idTokenPricedFk}`
        if (seenKey.has(key)) return
        seenKey.add(key)

        const count = await orbitTransactionCollection.getTransactionCountForRewardByToken(
          address,
          Number(round),
          idTokenPricedFk
        )

        this.$set(this.transactionCountMap, key, count)
      })
    )

    this.isLoadingTransactionCounts = false
  }

  getTransactionCountKey(item: OrbitRoundReward): string | null {
    const address = item.address
    const round = item.orbitRound?.round
    const idTokenPricedFk = item.tokenPriced?.idTokenPricedPk
    if (!address || round == null || idTokenPricedFk == null) return null
    return `${address}|${round}|${idTokenPricedFk}`
  }

  getTransactionsDisplay(item: OrbitRoundReward): string {
    if (this.isLoadingTransactionCounts) {
      return this.$translate('view.ListOrbitRewardsView.loading')
    }

    const key = this.getTransactionCountKey(item)
    if (!key) return 'N/A'

    const count = this.transactionCountMap[key]
    if (count == null) return 'N/A'

    return String(count)
  }

  getRoundChipVariant(round: number): number {
    return Math.abs(round) % 10
  }

  getRewardChipClasses(reward: OrbitRoundReward): string[] {
    const round = (reward.orbitRound && reward.orbitRound.round) || 0
    const variant = this.getRoundChipVariant(round)
    return [
      'list-orbit-rewards-view__reward-chip',
      `list-orbit-rewards-view__reward-chip--round-${variant}`,
    ]
  }

  async checkOwnerWallet() {
    if (!$.walletAdapter.n3Address) {
      this.isOwnerWallet = false
      return
    }

    try {
      const owners = await OrbitHelper.getOwners()
      this.isOwnerWallet = !!owners.find(
        (o: string) => o === $.walletAdapter.n3Address
      )
      if (!this.isOwnerWallet) {
        $.walletAdapter.disconnectN3Wallet()
        $.toast.error(
          'You are being disconnected! Your wallet is not an owner wallet.'
        )
      }
    } catch {
      this.isOwnerWallet = false
    }
  }

  handleAddressFilter() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout)
    }

    this.filterTimeout = setTimeout(() => {
      const addressValue = this.filterAddress.trim()

      if (addressValue) {
        this.collection.address = addressValue
      } else {
        this.collection.address = null
      }

      this.populateResources()
    }, 500)
  }

  connectN3Address() {
    $.modal.open('connectWalletModal', {
      networkNamespace: NetworkNamespace.n3,
    })
  }

  disconnectN3Address() {
    $.walletAdapter.disconnectN3Wallet()
  }

  truncateAddress(address: string) {
    return address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-5)}`
      : null
  }

  formatAmount(amount: number | string, decimals: number): string {
    const divisor = 10 ** decimals
    const value = Number(amount) / divisor

    let formatted = value.toFixed(decimals)

    formatted = formatted.replace(/\.?0+$/, '')

    return formatted
  }

  formattedAmount(reward: OrbitRoundReward) {
    if (reward.amount == null || !reward.tokenPriced) {
      return 'N/A'
    }

    const amount = this.formatAmount(
      Number(reward.amount),
      reward.tokenPriced?.decimals ?? 0
    )

    return `${amount} ${reward.tokenPriced?.symbol || ''}`
  }

  copyToClipboard(val: string) {
    $.utils.copyToClipboard(val)
    $.toast.info('system.info.copiedToClipboard')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange() {
    await this.checkOwnerWallet()
  }

  selectReward(item: OrbitRoundReward) {
    const index = this.selectedRewards.findIndex(
      r => r.idOrbitRoundRewardPk === item.idOrbitRoundRewardPk
    )
    if (index !== -1) {
      this.selectedRewards.splice(index, 1)
    } else {
      this.selectedRewards.push(item)
    }
  }

  selectAllApprovable() {
    const ids = new Set(this.selectedRewards.map(r => r.idOrbitRoundRewardPk))
    this.approvableRewards.forEach((r: OrbitRoundReward) => {
      if (!ids.has(r.idOrbitRoundRewardPk)) {
        ids.add(r.idOrbitRoundRewardPk)
        this.selectedRewards.push(r)
      }
    })
  }

  clearSelection() {
    this.selectedRewards = []
  }

  removeRewardFromSelection(reward: OrbitRoundReward) {
    this.selectedRewards = this.selectedRewards.filter(
      r => r.idOrbitRoundRewardPk !== reward.idOrbitRoundRewardPk
    )
  }

  openApproveModal(reward: OrbitRoundReward) {
    if (!$.walletAdapter.n3Address) {
      $.modal.open('connectWalletModal', {
        networkNamespace: NetworkNamespace.n3,
      })
      return
    }

    this.selectedReward = reward
    this.selectedRewards = []
    this.showApproveModal = true
  }

  openMultiApproveModal() {
    if (!$.walletAdapter.n3Address) {
      $.modal.open('connectWalletModal', {
        networkNamespace: NetworkNamespace.n3,
      })
      return
    }

    if (this.selectedRewards.length === 0) return

    this.selectedReward = null
    this.selectedRewards = this.selectedRewards.map(r =>
      Object.assign(new OrbitRoundReward(), r)
    )
    this.showApproveModal = true
  }

  async closeApproveModal() {
    this.showApproveModal = false
    this.selectedReward = null
    this.selectedRewards = []
    await this.populateResources()
  }

  async rejectReward(orbitRoundReward: OrbitRoundReward) {
    if (this.isUpdating) return

    if (orbitRoundReward.status !== 'pending') {
      $.toast.error(
        $.translate('view.ListOrbitRewardsView.cannotRejectNonPending')
      )
      return
    }

    try {
      this.isUpdating = true
      orbitRoundReward.status = 'rejected'
      orbitRoundReward.updatedAt = DateHelper.formatDateForBackend(
        Date.now()
      ) as any

      await orbitRoundReward.persistOrbitRoundReward()

      $.toast.success($.translate('view.ListOrbitRewardsView.rejectedSuccess'))

      await this.populateResources()
    } catch (err) {
      $.toast.error($.translate('view.ListOrbitRewardsView.rejectedError'))
      console.error(err)
    } finally {
      this.isUpdating = false
    }
  }

  statusLabel(status: string | null): string {
    if (!status) return '—'
    const distSuffix = '_distributed_to_others'
    if (status.endsWith(distSuffix) && status !== 'distributed_to_others') {
      const baseKey = status.slice(0, -distSuffix.length)
      const baseLabel =
        $.translate(`view.ListOrbitRewardsView.status_${baseKey}`) || baseKey
      const tail = $.translate(
        'view.ListOrbitRewardsView.statusSuffixDistributedToOthers'
      )
      return `(${baseLabel}) ${tail}`
    }
    const key = `view.ListOrbitRewardsView.status_${status}`
    return $.translate(key) || status
  }

  statusBadgeClass(status: string | null): string {
    const base =
      'inline-block px-3 py-1 rounded-full font-semibold text-sm capitalize'
    const distSuffix = '_distributed_to_others'
    if (
      status &&
      status.endsWith(distSuffix) &&
      status !== 'distributed_to_others'
    ) {
      const baseStatus = status.slice(0, -distSuffix.length)
      switch (baseStatus) {
        case 'pending':
          return `${base} bg-yellow-100 text-yellow-800 ring-1 ring-violet-300`
        case 'approved':
          return `${base} bg-green-100 text-green-800 ring-1 ring-violet-300`
        case 'rejected':
          return `${base} bg-red-100 text-red-800 ring-1 ring-violet-300`
        case 'expired':
          return `${base} bg-gray-200 text-gray-600 ring-1 ring-violet-300`
        default:
          return `${base} bg-violet-100 text-violet-800`
      }
    }
    switch (status) {
      case 'pending':
        return `${base} bg-yellow-100 text-yellow-800`
      case 'approved':
        return `${base} bg-green-100 text-green-800`
      case 'rejected':
        return `${base} bg-red-100 text-red-800`
      case 'claimed':
        return `${base} bg-blue-100 text-blue-800`
      case 'distributed_to_others':
        return `${base} bg-violet-100 text-violet-800`
      case 'expired':
        return `${base} bg-gray-200 text-gray-600`
      default:
        return `${base} bg-slate-100 text-slate-800`
    }
  }

  getExpiresAtDisplay(item: OrbitRoundReward): string {
    const expiresAtMs = OrbitHelper.claimEndMsForReward(
      item,
      this.claimEndByRound
    )
    if (expiresAtMs == null || expiresAtMs <= 0) return 'N/A'

    if (
      item.status === 'expired' ||
      item.status === 'expired_distributed_to_others'
    ) {
      return DateHelper.formatDatetime(expiresAtMs)
    }

    const now = Date.now()
    if (now > expiresAtMs) {
      return `${DateHelper.formatDatetime(expiresAtMs)} (expired)`
    }

    return DateHelper.formatDatetime(expiresAtMs)
  }

  async syncRewards() {
    if (this.isSyncing) return

    try {
      this.isSyncing = true

      const allRewardsCollection = new OrbitRoundRewardCollection()
      allRewardsCollection.orderBy = 'createdAt'
      allRewardsCollection.asc = false
      allRewardsCollection.limit = 9999
      allRewardsCollection.perPage = 9999

      await allRewardsCollection.queryAsPage()

      if (allRewardsCollection.items.length === 0) {
        $.toast.info($.translate('view.ListOrbitRewardsView.noRewardsToSync'))
        await this.populateResources()
        return
      }

      const userAddresses = [
        ...new Set(
          allRewardsCollection.items.map(
            orbitRoundReward => orbitRoundReward.address!
          )
        ),
      ]

      const claimablesByUser = new Map<
        string,
        Array<{
          project: string
          instanceId: number
          round: number
          claimable: boolean
        }>
      >()

      for (const userAddress of userAddresses) {
        const userScriptHash = NeoHelper.getScriptHashFromAddress(userAddress)
        if (!userScriptHash) {
          console.error('userScriptHash is required')
          continue
        }

        const rawClaimables = await OrbitHelper.getUserClaimables(
          userScriptHash
        )

        const decoded = OrbitHelper.decodeUserClaimablesMap(rawClaimables)

        claimablesByUser.set(userAddress, decoded)
      }

      const rewardsToSync = (allRewardsCollection.items || []).filter(
        (r: OrbitRoundReward) =>
          r.status === 'pending' &&
          r.address &&
          r.orbitProject?.contract?.hash &&
          r.orbitProject?.instanceId != null &&
          r.orbitRound?.round != null &&
          !(r.orbitRound && r.orbitRound.isRunning)
      )

      let syncedCount = 0

      for (const reward of rewardsToSync) {
        const claimablesList = claimablesByUser.get(reward.address!)

        if (!claimablesList || claimablesList.length === 0) continue

        const projectHash = (reward.orbitProject!.contract!.hash || '')
          .replace(/^0x/i, '')
          .toLowerCase()
        const instanceId = Number(reward.orbitProject!.instanceId)
        const round = Number(reward.orbitRound!.round)

        const match = claimablesList.find(
          c =>
            (c.project || '').replace(/^0x/i, '').toLowerCase() ===
              projectHash &&
            c.instanceId === instanceId &&
            c.round === round
        )

        if (match) {
          reward.status = match.claimable ? 'approved' : 'rejected'
          reward.updatedAt = DateHelper.formatDateForBackend(Date.now()) as any

          await reward.persistOrbitRoundReward()

          syncedCount++
        }
      }

      $.toast.success(
        $.translate('view.ListOrbitRewardsView.syncSuccess', {
          count: syncedCount,
          total: rewardsToSync.length,
        })
      )

      await this.populateResources()
    } catch (err) {
      $.toast.error($.translate('view.ListOrbitRewardsView.syncError'))
      console.error(err)
    } finally {
      this.isSyncing = false
    }
  }
}
